import {
    TO_PAYMENT,
    TO_SHIPPING
  } from '../../GlobalStateContainer'
  

  export function toPayment() {
    return {type: TO_PAYMENT}
  }
  
  export function toShipping() {
    return {type: TO_SHIPPING}
  }

  export function continueCheckout() {
    return {type: TO_PAYMENT}
  }